import PreferenceStatusButtons from './PreferenceStatusButtons';

const SubscribeFullWidthButton = ({
    status,
    subscribed,
    onStatusChange,
    onClick,
    disabled = false,
}) => {
    const resolvedStatus = status !== undefined ? status : (subscribed ? true : null);
    const handleStatusChange = (nextStatus) => {
        if (onStatusChange) {
            onStatusChange(nextStatus);
            return;
        }
        if (onClick) {
            onClick(nextStatus);
        }
    };

    return (
        <PreferenceStatusButtons
            status={resolvedStatus}
            onStatusChange={handleStatusChange}
            variant='labeled'
            className='subscribeFullWidthPreference'
            disabled={disabled}
        />
    );
};

export default SubscribeFullWidthButton;
